var boxShadowColor = "rgba(25, 48, 82, 0.1)";
var boxShadow = {
  nano: {
    horizontalOffset: 0,
    verticalOffset: 2,
    blur: 6,
    color: boxShadowColor
  },
  tiny: {
    horizontalOffset: 0,
    verticalOffset: 4,
    blur: 8,
    color: boxShadowColor
  },
  small: {
    horizontalOffset: 0,
    verticalOffset: 8,
    blur: 14,
    color: boxShadowColor
  },
  medium: {
    horizontalOffset: 0,
    verticalOffset: 12,
    blur: 16,
    color: boxShadowColor
  },
  big: {
    horizontalOffset: 0,
    verticalOffset: 15,
    blur: 18,
    color: boxShadowColor
  },
  large: {
    horizontalOffset: 0,
    verticalOffset: 18,
    blur: 20,
    color: boxShadowColor
  }
};
export default boxShadow;